import React from 'react';
import { InputFormDescription } from '../../styles/Input.styled';

const EnergyUseIntro = () => (
    <InputFormDescription>
        Energy usage includes all fuel and electricity used during the assessment period on-site, in owned machinery, or by contractors for the transportation of horses. (Note: The transport of raw materials, such as feed and bedding, and waste is captured on earlier tabs).
        <br />
        To make data entry easier, we have provided several options:

        <ol>
            <li>Enter all <strong>electricity consumption and production</strong> data.</li>
            <li>Enter as much data as possible on the <strong>total fuel tab</strong> based on invoices, receipts, or records.</li>
            <li>If you use <strong>contractors</strong> and do not know their specific fuel usage, use the contractors tab to estimate it.</li>
            <li>If <strong>company vehicle</strong> fuel usage (cars, vans, horse boxes) was not captured in step 1, use the "fuel purchased from service stations" tab to enter total mileage and vehicle type.</li>
            <li>For <strong>horses transported</strong> in vehicles not captured in the previous three tabs, use the horse transport tab to record the number of horses, distance travelled, and vehicle type.</li>
        </ol>
    </InputFormDescription>
);

export default EnergyUseIntro;
